import { RequestManager } from '@jaseeey/request-manager';
import { useMessagePack } from 'composables/message-pack';
import { defineStore } from 'pinia';
import env from 'src/configs/env';
import { computed, ref } from 'vue';

export const useJobTitleSearchStore = defineStore('job-title-search', () => {
    const { decodeResponse } = useMessagePack();

    const similarJobTitles = ref(null);
    const loadingState = ref(false);

    const isLoading = computed(() => {
        return loadingState.value;
    });

    const hasResults = computed(() => {
        return similarJobTitles.value !== null;
    });

    async function loadSimilarJobTitles(title, limit = 15) {
        title = title.trim().replace(/\s+/g, ' ');
        if (!title) {
            similarJobTitles.value = null;
            throw new Error('Title parameter is required');
        }
        try {
            loadingState.value = true;
            const params = {
                q: title,
                include: 'similar',
                limit
            };
            const response = await RequestManager.call(this.$api, 'get', '/v1/public/job-titles', {}, {
                responseType: 'arraybuffer',
                headers: {
                    accept: 'application/json,application/msgpack',
                    authorization: generateBasicAuthToken()
                },
                params: params
            });
            const decodedData = decodeResponse(response);
            if (!decodedData?.similar) {
                similarJobTitles.value = null;
                return null;
            }
            similarJobTitles.value = decodedData.similar.map(s => s.title);
            return similarJobTitles.value;
        } finally {
            loadingState.value = false;
        }
    }

    function generateBasicAuthToken() {
        return `Basic ${btoa([env.siteUsername, env.sitePassword].join(':'))}`;
    }

    function prepareSimilarJobTitlesForSearch() {
        clearSimilarJobTitles();
        loadingState.value = true;
    }

    function clearSimilarJobTitles() {
        similarJobTitles.value = null;
    }

    return {
        // State
        similarJobTitles,
        // Getters
        isLoading,
        hasResults,
        // Actions
        loadSimilarJobTitles,
        prepareSimilarJobTitlesForSearch,
        clearSimilarJobTitles
    };
});
